export default {
	red: { color: '232, 55, 0', label: 'JAM' },
	blue: { color: '11, 114, 255', label: 'COMPLETE' },
	orange: { color: '255, 169, 6', label: 'WAITING' },
	green: { color: '0, 255, 0', label: 'READY' },
}
